require('./_wks-define')('asyncIterator');



/*****************
 ** WEBPACK FOOTER
 ** /Users/endriu/Work/adoratorio/temp/ahs-site/ahs/~/core-js/modules/es7.symbol.async-iterator.js
 ** module id = 270
 ** module chunks = 0
 **/